import React, {useEffect, useState} from "react";
import {motion} from "framer-motion";
import {EditOutlined, EyeOutlined, PlusOutlined, CheckOutlined, DeleteOutlined, CloseOutlined} from "@ant-design/icons";
import {useDispatch, useSelector} from "react-redux";
import {setPromoField, updatePromoFields} from "../../store/slices/promoFormSlice";

import {message} from "antd";
import api from "../../api/promosApi";



const defaultDrawerBg =
    "bg-[#070A12]/96 backdrop-blur-2xl border-l border-white/10";

const GlobalDrawer = ({
    isOpen,
    onClose,
    children,
    drawerBgColor = defaultDrawerBg,
    width = 400,
    status,
}) => {
    const [statusColor, setStatusColor] = useState("bg-red-400");
    const [statusIcon, setStatusIcon] = useState(<EyeOutlined/>);
    const promo = useSelector((state) => state.promoForm);
    const dispatch = useDispatch();
    useEffect(() => {
        switch (status) {
            case "show":
                setStatusColor("bg-blue-500");
                setStatusIcon(<EyeOutlined className="text-white text-lg"/>);
                break;
            case "edit":
                setStatusColor("bg-yellow-500");
                setStatusIcon(<EditOutlined className="text-white text-lg"/>);
                break;
            case "create":
                setStatusColor("bg-lime-500");
                setStatusIcon(<PlusOutlined className="text-white text-lg"/>);
                dispatch(updatePromoFields({
                    title: "",
                    participantsCount: 0,
                    prizePlacesCount: 0,
                    totalAmount: 0,
                    currentAmount: 0,
                    status: "в ожидании",
                    winnersCount: 0,
                    durationDays: 0,
                    tokenType: "",
                    creatorUserId: 1,
                    link: "put here link telegram channel or group",
                    maxParticipantsCount: 0,
                    category: {
                        category_name: "",
                        positions: [],
                    },
                }))
                break;
            default:
                setStatusColor("bg-red-500");
                setStatusIcon(<EyeOutlined className="text-white text-lg"/>);
        }
    }, [status]);

    const createPromo = async () => {
        if (status === 'create') {
            try {
                console.log('create promo here form')
                console.log(promo)
                const response = await api.promosApi.create(promo);
                console.log(response.id)
                message.success('promo success created.')
              //  refreshPage()
            } catch (e) {
                console.log(e)
                message.error('error create promo')
            }
        } else {

            message.warning('some wrong')
        }
    }
    const deletePromo = async () => {
        if (promo?.id !== 0 ){
            try {
                console.log(promo?.id)
                const response = await api.promosApi.delete(promo?.id)
                console.log(response)
                message.success('promo success delete')
                refreshPage()
            } catch (e){
                console.log(e)
                message.error('some error when delete promo')
            }
        }
    }
    const updatePromo = async () => {
        try {
            if (promo.id !== 0) {
                console.log("Original promo:", promo);

                // Создаём новый объект без id
                const { id, ...promoData } = promo;

                console.log("Promo без id:", promoData);

                const response = await api.promosApi.update(id, promoData);
                console.log("Response:", response);

                message.success("Promo successfully updated");
            }
        } catch (e) {
            console.error(e);
            message.error("Some error occurred while updating promo");
        }
    };

    const refreshPage =  ()=>{
        window.location.reload();
    }
    return (
        <div
            className={`fixed inset-0 z-50 flex justify-end ${
                isOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
            } transition-opacity duration-300`}
        >
            {/* Оверлей */}
            <div
                className="absolute inset-0 z-10 bg-black/55 backdrop-blur-[3px]"
                onClick={onClose}
            />

            <motion.div
                initial={{ x: "100%" }}
                animate={{ x: isOpen ? "0%" : "100%" }}
                exit={{ x: "100%" }}
                transition={{ type: "spring", stiffness: 300, damping: 30 }}
                className={`relative z-20 flex h-full max-h-screen flex-col text-white shadow-[-16px_0_48px_-12px_rgba(0,0,0,0.75)] ${drawerBgColor}`}
                style={{
                    minWidth: Math.min(width, typeof window !== "undefined" ? window.innerWidth : width),
                    width: "fit-content",
                    maxWidth: "100%",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex shrink-0 flex-row items-center justify-between gap-3 border-b border-white/10 bg-white/[0.04] px-4 py-3 backdrop-blur-md">
                    <div className="flex flex-wrap gap-2">
                        <button
                            type="button"
                            onClick={createPromo}
                            className="flex cursor-pointer items-center gap-2 rounded-xl border border-emerald-400/25 bg-emerald-500/10 px-3 py-2 text-[13px] text-emerald-100 transition hover:border-emerald-400/40 hover:bg-emerald-500/20"
                        >
                            <CheckOutlined />
                            {status === "create" ? <span>Confirm</span> : null}
                        </button>

                        <button
                            type="button"
                            onClick={updatePromo}
                            className="flex items-center gap-2 rounded-xl border border-amber-400/25 bg-amber-500/10 px-3 py-2 text-[13px] text-amber-100 transition hover:border-amber-400/40 hover:bg-amber-500/20"
                        >
                            <EditOutlined />
                            {status === "edit" ? <span>Confirm</span> : null}
                        </button>

                        <button
                            type="button"
                            onClick={deletePromo}
                            className="flex items-center gap-2 rounded-xl border border-rose-400/25 bg-rose-500/10 px-3 py-2 text-[13px] text-rose-100 transition hover:border-rose-400/40 hover:bg-rose-500/20"
                        >
                            <DeleteOutlined />
                            {status === "delete" ? <span>Confirm</span> : null}
                        </button>
                    </div>

                    <button
                        type="button"
                        onClick={onClose}
                        className="inline-flex items-center gap-2 rounded-xl border border-white/10 bg-white/[0.06] px-3 py-2 text-[13px] text-white/80 transition hover:border-rose-400/35 hover:bg-rose-500/15 hover:text-rose-100"
                    >
                        Close
                        <CloseOutlined />
                    </button>
                </div>

                <div
                    className={`mx-4 mt-3 flex shrink-0 items-center gap-2 rounded-xl border border-white/10 px-3 py-2 text-white shadow-inner ${statusColor}`}
                >
                    {statusIcon}
                    <span className="text-xs font-semibold tracking-wide">{String(status).toUpperCase()}</span>
                </div>

                <div className="min-h-0 flex-1 overflow-y-auto p-4 pb-10">{children}</div>
            </motion.div>
        </div>
    );
};

export default GlobalDrawer;
